export const partnerCode = "pkgc197";
export const seedKey = "4f7dRw9$X=";

export const RMGPartnerName = "Geoff Banks";
export const RMGPartnerID = "10693";
export const RMGSeedKey = "jlY5rhm7LpUuqT6H";
